export const MAX_MOBILE_SIZE = 992;
